import React from 'react';
import { Target, ArrowRight, Zap } from 'lucide-react';
import { Link } from 'react-router-dom';

const TridentOpportunityWidget = () => {
    return (
        <div className="bg-gradient-to-br from-indigo-600 to-violet-800 rounded-3xl shadow-lg p-5 relative overflow-hidden group h-full min-h-[200px] flex flex-col justify-between">
            {/* Effet lumineux en arrière plan */}
            <div className="absolute -right-10 -top-10 w-48 h-48 bg-indigo-400/30 rounded-full blur-3xl group-hover:scale-150 transition-transform duration-700 ease-out"></div>
            
            <div className="relative z-10">
                <div className="flex items-center gap-3 mb-3">
                    <div className="p-2 bg-white/20 backdrop-blur-md text-white rounded-xl shadow-inner">
                        <Target size={18} />
                    </div>
                    <span className="text-[10px] font-black text-indigo-100 uppercase tracking-widest bg-white/10 px-2 py-0.5 rounded-lg">Allocation Tactique</span>
                </div>
                
                <h3 className="text-xl font-black text-white leading-tight mb-2">
                    Nouveau Scan Quantamental
                </h3>
                <p className="text-indigo-100/80 text-xs font-medium leading-relaxed max-w-[95%]">
                    Découvrez les meilleures opportunités basées sur les fondamentaux et le momentum.
                </p>
            </div>

            <Link to="/portfolio" className="relative z-10 mt-4 bg-white text-indigo-600 font-bold py-2.5 px-4 rounded-xl shadow-md hover:shadow-xl hover:bg-indigo-50 transition-all flex items-center justify-between w-full group/btn text-sm">
                <span className="flex items-center gap-2"><Zap size={16} className="text-amber-500"/> Lancer l'analyse</span>
                <ArrowRight size={16} className="group-hover/btn:translate-x-1 transition-transform" />
            </Link>
        </div>
    );
};

export default TridentOpportunityWidget;
